import { I18n } from "@/i18n/I18n";
import { ProjectCards } from "../cards/ProjectCards";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useEffect, useState } from "react";
import { CardPlaceholder } from "../cards/CardPlaceholder";
import { useShallow } from "zustand/react/shallow";
import { ProjectParentType } from "@/backend/models/project";

export function RecentProjects() {
  const fetchRecentProjects = useProjectStore(state => state.fetchRecentProjects);
  const recentProjects = useProjectStore(useShallow(state => state.recentProjects));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    void fetchRecentProjects().finally(() => {
      setLoading(false);
    });
  }, [fetchRecentProjects]);

  if (loading) {
    return <CardPlaceholder />;
  }

  return (
    <div className="p-3 overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
      <div className="page-title">{I18n.get('recentProjects')}</div>
      <ProjectCards projects={recentProjects} parentType={ProjectParentType.WORKSPACE} hideCreateButton />
    </div>
  );
}
